import React from 'react';
import { Shield, Clock, Award, Headphones, TrendingUp, Users } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Shield,
      title: 'Safe & Secure',
      description: '100% safe delivery with comprehensive insurance coverage for your goods.'
    },
    {
      icon: Clock,
      title: 'On-Time Delivery',
      description: 'Guaranteed timely delivery with real-time tracking and updates.'
    },
    {
      icon: Award,
      title: 'Experienced Team',
      description: 'Professional drivers and handlers with years of logistics experience.'
    },
    {
      icon: Headphones,
      title: '24/7 Support',
      description: 'Round-the-clock customer support for all your queries and concerns.'
    },
    {
      icon: TrendingUp,
      title: 'Competitive Pricing',
      description: 'Best rates in the market with transparent pricing and no hidden costs.'
    },
    {
      icon: Users,
      title: 'Customer Focused',
      description: 'Dedicated to building long-term relationships with our valued clients.'
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-red-600">MAHESHXPRESS</span>?
          </h2>
          <p className="text-lg text-gray-600">
            We stand out in the logistics industry with our commitment to excellence and customer satisfaction.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-yellow-400 transition-colors duration-300">
                  <Icon className="w-7 h-7 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {reason.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;